export default __webpack_public_path__ + "static/media/style-angelusSlaton.50489edc.jpg";